<template>
  <div class="tips_content_box">
    <span @click="toErp" class="handleButton tips_content">推荐使用91家纺网erp，点击跳转</span>
  </div>
</template>

<script>
export default {
  name: 'ErpTips',
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    toErp () {
      window.open('http://erp.91jf.com','_blank')
    }
  }
}
</script>
<style scoped>
.tips_content_box {
  padding: 20px;
  background-color: #fff;

}
.tips_content {
  font-size: 16px;

}
</style>



// WEBPACK FOOTER //
// src/components/deal/third/components/ErpTips.vue